import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { TypesModel } from "common/models/page-models/types/types-data-model";

 
@Injectable()
export class TypesListDataService extends DataService<TypesModel > {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getType,http);
    }
 

   
    createInstance(): TypesModel {
        return new TypesModel();
    }

    
 
}